import React, { Component, PropTypes } from 'react';
import { Modal, Button, Row, Col, Checkbox, Spin, Alert } from 'antd';

import { ALLOWTYPE } from '../../../utils/questionManageType';

const CheckboxGroup = Checkbox.Group;

export default class SelectedModal extends Component {
    state = {
        vislble: false,
        source:[],
        target:[]
  }
  componentDidMount() {

  }
  showModal = () => {
    const { handleGetSelectedTree } = this.props;
    handleGetSelectedTree(() => {
        const { data:{ source, target } } = this.props;
        this.setState({
            source: source.map(v =>({relate_type: v.relate_type, relate_id: v.relate_name.map(val=>val.id)})),
            target: target.map(v =>({relate_type: v.relate_type, relate_id: v.relate_name.map(val=>val.id)})),
            visible: true
        })
    });
  }
  handleOk = e => {
    
    const { source, target } = this.state;
    const { handleImportQuestion } = this.props;
    handleImportQuestion({source, target},()=> this.setState({visible: false}));
  }

  handleCancel = e => {
    const { handleCancelList } = this.props;
    this.setState({visible: false})
  }

  checkBoxChange = (relate_id, relate_type, type) => {
        const { source, target } = this.state;
        if (type === 'source') {
            source.map((val,key) => {
            if (val.relate_type == relate_type) source[key].relate_id = relate_id;
        })
        }else if (type === 'target') {
            target.map((val,key) => {
                if (val.relate_type == relate_type) target[key].relate_id = relate_id;
            })
        }
        this.setState({ source, target });
  }


    render() {
     const { name, data, title, disabled, loading, error } = this.props;
    const source = data.source && data.source.map(v => ({name:ALLOWTYPE[v.relate_type], type: v.relate_type, options: v.relate_name.map(val=>({label:val.name, value: val.id}))}));
    const target = data.target && data.target.map(v => ({name:ALLOWTYPE[v.relate_type], type: v.relate_type, options: v.relate_name.map(val=>({label:val.name, value: val.id}))}));
    const sourceDefaultValue = data.source && data.source.map(v => (v.relate_name.map(val=>val.id)));
    const targetDefaultValue = data.target && data.target.map(v => (v.relate_name.map(val=>val.id)));
     return(
            <div>
                <div>
                    <Button disabled={ disabled } type="primary" onClick={ this.showModal }>{ name }</Button>
                    <Modal className="selectedModal" title= { title } visible={ this.state.visible }
                    onOk={ this.handleOk } onCancel={ this.handleCancel }
                    >
                        
                        <Spin spinning={ loading }>
                            <Row>
                            <Col span={12}>
                                    <div className="title">源节点</div>
                                    <div>
                                        {
                                            !loading && source && source.map((val,key) =>
                                                <div key= { key }>
                                                    {
                                                        !!val.options.length && 
                                                        <div>
                                                            <div className="subtitle">
                                                                { val.name }
                                                            </div>
                                                            <div>
                                                                 <CheckboxGroup options={ val.options } defaultValue={ sourceDefaultValue[key] } onChange={ checkValues => this.checkBoxChange(checkValues, val.type, 'source') } />
                                                            </div>
                                                        </div>
                                                    }
                                                    
                                                </div>
                                            )
                                        }
                                    </div>
                            </Col>
                            <Col span={12}>
                                <div className="title">目标节点</div>
                                <div>
                                        {
                                            !loading && target && target.map((val,key) =>
                                                <div key= { key }>
                                                    {
                                                        !!val.options.length && 
                                                        <div>
                                                            <div className="subtitle">
                                                                { val.name }
                                                            </div>
                                                            <div>
                                                                 <CheckboxGroup options={ val.options } defaultValue={ targetDefaultValue[key] } onChange={ checkValues => this.checkBoxChange(checkValues, val.type, 'target') } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                            </Col>
                        </Row>
                        <Row>
                            
                        </Row>
                        </Spin>
                    </Modal>
                </div>
            </div>
     )
}
}



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/bulk_Import/SelectedModal.js